module.exports = __webpack_public_path__ + "img/icon_fenxi.0e9fe2d6.png";